import { Pagination as BootstrapPagination, Form } from "react-bootstrap";
import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

const createLinksFromRange = (start, stop, step = 1) => {
  return Array.from({ length: (stop - start) / step }, (_, i) => ({
    label: start + i,
  }));
};

const calcActiveRange = (activePage, totalPages) => {
  const pageNumString = activePage.toString();

  let rangeStart = Number(
    pageNumString.slice(0, pageNumString.length - 1) + "1"
  );
  if (pageNumString % 10 === 0) rangeStart = rangeStart - 10;
  if (rangeStart === 0) rangeStart = 1;

  let rangeEnd = rangeStart + 10;
  if (totalPages < rangeEnd) rangeEnd = totalPages + 1;

  return [rangeStart, rangeEnd];
};

export const Pagination = ({
  activePage,
  rowsCount,
  rowsPerPage,
  setRowsPerPage,
  totalPages,
  setActivePage,
  loading,
  rowsPerPageSelectOptions = [5],
  id,
}) => {
  const { t } = useTranslation("Shared");
  const beginning = activePage === 1 ? 1 : rowsPerPage * (activePage - 1) + 1;
  const end =
    activePage === totalPages ? rowsCount : beginning + rowsPerPage - 1;

  const [links, setLinks] = useState(
    createLinksFromRange(...calcActiveRange(activePage))
  );

  useEffect(() => {
    setLinks(createLinksFromRange(...calcActiveRange(activePage, totalPages)));

    //eslint-disable-next-line
  }, [activePage, totalPages]);

  return (
    <BootstrapPagination
      className="d-flex align-items-center mt-2 mb-0 px-2 py-2"
      id={id}
    >
      <div className="ml-2 records-select">
        <Form.Select
          className="w-50"
          style={{}}
          value={rowsPerPage}
          onChange={(e) => {
            setRowsPerPage(Number(e.target.value));
            setActivePage(1);
          }}
          disabled={loading}
        >
          {rowsPerPageSelectOptions.map((pageSize) => (
            <option
              key={pageSize}
              value={pageSize}
              disabled={pageSize === rowsPerPage}
            >
              {t("queue.page_size", { pageSize })}
            </option>
          ))}
        </Form.Select>
      </div>
      <div className="pagination justify-content-center">
        <BootstrapPagination.First
          disabled={activePage === 1 || loading || rowsCount === 0}
          onClick={() => setActivePage(1)}
        />
        <BootstrapPagination.Prev
          disabled={activePage === 1 || loading || rowsCount === 0}
          onClick={() => setActivePage(activePage - 1)}
        />
        {links.map((link) => {
          if (link?.url !== null)
            return (
              <BootstrapPagination.Item
                key={Number(link.label)}
                active={activePage === Number(link.label)}
                onClick={() => setActivePage(Number(link.label))}
                disabled={loading}
              >
                <span dangerouslySetInnerHTML={{ __html: link.label }} />
              </BootstrapPagination.Item>
            );
          return null;
        })}
        <BootstrapPagination.Next
          disabled={activePage === totalPages || loading || rowsCount === 0}
          onClick={() => setActivePage(activePage + 1)}
        />
        <BootstrapPagination.Last
          disabled={activePage === totalPages || loading || rowsCount === 0}
          onClick={() => setActivePage(totalPages)}
        />
      </div>

      <div className="ml-2 justify-content-end records-label">
        {t("queue.records", {
          recordsRange: beginning === end ? end : `${beginning} - ${end}`,
          totalRecords: rowsCount,
          totalPages: totalPages,
        })}
      </div>
    </BootstrapPagination>
  );
};
